import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import showGallery from './events';
import { IMAGE } from './Image';
import { imageClass } from './styles';

var Group =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Group, _PureComponent);

  var _super = _createSuper2(Group);

  function Group() {
    _classCallCheck(this, Group);

    return _super.apply(this, arguments);
  }

  _createClass(Group, [{
    key: "handleClick",
    value: function handleClick(index) {
      var children = this.props.children;
      var images = [];
      var current = 0;
      Children.toArray(children).forEach(function (child, i) {
        if (child && child.type && child.type.symbolType === IMAGE) {
          if (index === i) current = images.length;
          var _child$props = child.props,
              src = _child$props.src,
              href = _child$props.href;
          images.push({
            thumb: src,
            src: href || src,
            key: i
          });
        }
      });
      showGallery(images, current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          pile = _this$props.pile,
          style = _this$props.style,
          props = _objectWithoutProperties(_this$props, ["children", "pile", "style"]);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: imageClass('group', pile && 'pile'),
          style: style
        }, Children.toArray(this.props.children).map(function (child, i) {
          return (
            /*#__PURE__*/
            cloneElement(child, _objectSpread2(_objectSpread2({}, props), {}, {
              onClick: _this.handleClick.bind(_this, i)
            }))
          );
        }))
      );
    }
  }]);

  return Group;
}(PureComponent);

Group.displayName = void 0;
export default Group;